module.exports = __webpack_public_path__ + "static/media/icono_conjunto.28c4250e.svg";